// BIRTH-TIME-1: one client-side check for a birth time that a form is about to SAVE.
// Mirrors backend/utils/birth_time.py so the form says what the server would 422 on:
//   * 24-hour HH:MM, HH 00-23, MM 00-59 (a single-digit hour is fine: "7:05");
//   * 12-hour "hh:mm AM/PM", HH 01-12 (the shape the own-profile field shows).
// Anything else ("25:86", "24:00", "12:60", "") is an error.

export const BIRTH_TIME_ERROR = 'Enter a real time: HH:MM, 00:00 to 23:59 (e.g. 00:46 or 14:30).';

const TIME_24 = /^(\d{1,2}):(\d{2})$/;
const TIME_12 = /^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/;

export function isValidBirthTime(value) {
  if (typeof value !== 'string') return false;
  const s = value.trim();
  let m = s.match(TIME_24);
  if (m) {
    const h = Number(m[1]); const min = Number(m[2]);
    return h >= 0 && h <= 23 && min >= 0 && min <= 59;
  }
  m = s.match(TIME_12);
  if (m) {
    const h = Number(m[1]); const min = Number(m[2]);
    return h >= 1 && h <= 12 && min >= 0 && min <= 59;
  }
  return false;
}

// null when valid, else the inline error text.
export function birthTimeError(value) {
  return isValidBirthTime(value) ? null : BIRTH_TIME_ERROR;
}

// Parse any birth-time string (12-hour with AM/PM or a.m./p.m., or 24-hour)
// to a clean 24-hour HH:MM string, never keeping AM/PM after converting.
export function parseTime(timeInput) {
  if (!timeInput) return '';
  const trimmed = String(timeInput).trim();
  if (!trimmed) return '';

  const timeMatch = trimmed.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*([ap]\.?m\.?)?$/i) ||
                    trimmed.match(/(\d{1,2}):(\d{2})(?::\d{2})?\s*([ap]\.?m\.?)?/i);
  if (timeMatch) {
    let hours = parseInt(timeMatch[1], 10);
    const minutes = timeMatch[2];
    const ampm = timeMatch[3]?.toLowerCase().replace(/\./g, '');

    if (ampm === 'pm' && hours < 12) {
      hours += 12;
    } else if (ampm === 'am' && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes}`;
  }

  return trimmed;
}

// A FastAPI error body as one line of text: `detail` can be a string, a
// {code, message} object, or a list of validation errors (a 422).
export function apiErrorText(data, fallback) {
  const d = data && data.detail;
  if (typeof d === 'string') return d;
  if (d && typeof d === 'object' && !Array.isArray(d) && d.message) return d.message;
  if (Array.isArray(d) && d.length) {
    const msg = d[0] && d[0].msg;
    if (typeof msg === 'string') return msg.replace(/^Value error, /, '');
  }
  return (data && typeof data.message === 'string' && data.message) || fallback;
}

// True when a dasha endpoint said the STORED time cannot be built into a chart.
export function isInvalidBirthTimeError(data) {
  return !!(data && data.detail && data.detail.code === 'invalid_birth_time');
}
